import { render } from "./SupplierModal.vue?vue&type=template&id=b2b3b3b0&scoped=true"
import script from "./SupplierModal.vue?vue&type=script&lang=js"
export * from "./SupplierModal.vue?vue&type=script&lang=js"

import "./SupplierModal.vue?vue&type=style&index=0&id=b2b3b3b0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2b3b3b0"]])

export default __exports__